module.exports = __webpack_public_path__ + "img/IMG-20191208-WA0040.fe3164c2.jpg";